import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/sending` has no content of its own (`../sending.tsx` is now a bare
 * layout, #642) and is no longer a nav destination (#638).
 *
 * It used to land on Developer settings, which held the transactional-email
 * surface it was a hub for. The sidebar IA reorg (2026-08-14) retired that
 * page, so that target is itself a redirect now — and following it would put a
 * legacy *sending* path through two hops onto a webhook form, which is not
 * what anyone typing `/sending` was after. Points at Email templates instead:
 * a real page, still under `/sending`, and the closest thing left to what this
 * hub used to open onto.
 */
export const Route = createFileRoute("/dashboard/w/$workspaceId/sending/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/sending/templates",
      params: { workspaceId: params.workspaceId },
    });
  },
});
